import { createhttp } from 'lib/services/http';
import { accountBaseUrl } from 'constants/apiUrls';

const COMPANY_TAX_ID = `${accountBaseUrl}/taxId`;

export const http = createhttp({ baseURL: '/rest-api/account/v1' });

export const getCompanyTaxId = () => {
  return http.get(`${COMPANY_TAX_ID}`);
};

export const updateCompanyTaxId = (payload) => {
  return http.put(`${COMPANY_TAX_ID}`, payload);
};
